import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { readVideosList } from 'shared/modules/videos/actions';
import { CONTENT_TYPE } from 'shared/constants/general';
import EmptyState from 'shared/_components/empty-state';
import ListContainer from 'shared/components/ListContainer/ListContainer';
import VideoListItemDetails from './VideoListItemDetails';

export default function VideosList() {
  const videos = useSelector(s => s.videos.list);
  const dispatch = useDispatch();

  const [ready, setReady] = useState(false);

  const init = useCallback(async () => {
    await dispatch(readVideosList());
    setReady(true);
  }, [dispatch]);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <ListContainer
      page
      ready={ready}
      title="Videos"
      items={videos}
      actions={[
        // { label: 'Add Project', link: ROUTE.projects.create() }
      ]}
      emptyState={
        <EmptyState
          title="No finished videos yet"
          description="Finished videos from your projects will show up here."
        />
      }
      details={VideoListItemDetails}
      type={CONTENT_TYPE.VIDEO}
    />
  );
}
